import { Search, XCircle } from "lucide-react";
import { Input } from "./ui/input";
import React from "react";
import { cn } from "@/utils/classnames";

export default function SearchInput({ searchValue, setSearchValue }) {
  const id = React.useId();
  const inputRef = React.useRef(null);

  return (
    <div className="relative w-full lg:w-80">
      <Input
        id={`${id}-input`}
        ref={inputRef}
        className={cn("peer min-w-60 ps-9", Boolean(searchValue) && "pe-9")}
        value={searchValue ?? ""}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder="Search..."
        type="text"
        aria-label="Search by name or email"
      />
      <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-muted-foreground/80 peer-disabled:opacity-50">
        <Search size={16} strokeWidth={2} aria-hidden="true" />
      </div>
      {Boolean(searchValue) && (
        <button
          className="absolute inset-y-0 end-0 flex h-full w-9 items-center justify-center rounded-e-lg text-muted-foreground/80 outline-offset-2 transition-colors hover:text-foreground focus:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
          aria-label="Clear filter"
          onClick={() => {
            setSearchValue("");
            if (inputRef.current) {
              inputRef.current.focus();
            }
          }}
        >
          <XCircle size={16} strokeWidth={2} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
